export function scrollToTop() {
  const bmContent = document.querySelector('.bm-content');

  if (bmContent) {
    bmContent.scrollTop = 0;
  }
}
